module.exports = __webpack_public_path__ + "img/nuage.cba92169.svg";